import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect } from "react";

import man from '../assests/AI.mp4';
import man1 from '../assests/data.mp4';
import man2 from '../assests/Lang.mp4';
import man3 from '../assests/editing.mp4';

export default function Services() {
  //  useEffect(() => {
  //       window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  //     }, []);
  const categories = [
    {
      title: "Data Collection",
      icon: "🖼️",
      video: man1,
      items: [
        { label: "Image & Video Collection", path: "/services/image-video" },
        { label: "Audio Collection", path: "/services/audio" },
        { label: "Text Data Sourcing", path: "/services/text" }
      ]
    },
    {
      title: "Data Processing & Enhancement",
      icon: "🏷️",
      video: man,
      items: [
        { label: "Annotation & Labeling", path: "/services/annotation" },
        { label: "Audio & Video Tagging", path: "/services/tagging" },
        { label: "Text & Speech QA", path: "/services/qa" }
      ]
    },
    {
      title: "Language & Localization",
      icon: "🌐",
      video: man2,
      items: [
        { label: "Multilingual Transcription", path: "/services/transcription" },
        { label: "Translation & Localization", path: "/services/translation" },
        { label: "Dubbing & Voiceover", path: "/services/dubbing" }
      ]
    },
    {
      title: "Creative & Media Solutions",
      icon: "🎬",
      video: man3,
      items: [
        { label: "Video Editing", path: "/services/editing" },
        { label: "Content Creation", path: "/services/content" },
        { label: "Animation (2D & 3D)", path: "/services/animation" },
        { label: "Video Projects", path: "/services/projects" }
      ]
    }
  ];

  return (
    <section className="py-20 px-6 text-center bg-gradient-to-br from-black via-gray-900 to-black text-white">
      {/* Section Header */}
      <div className="max-w-6xl mx-auto text-center mb-16">
        <h2 className="text-4xl font-extrabold text-white mb-6 tracking-tight font-orbitron">
          Our Services
        </h2>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto font-raleway">
          From multilingual data collection to creative media solutions, we power AI with precision and cultural depth.
        </p>
      </div>

      {/* Service Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto">
        {categories.map(({ title, icon, items, video }, index) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.15 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-2xl shadow-lg border border-gray-700 p-8 cursor-pointer bg-black"
            whileHover={{ scale: 1.03 }}
          >
            {/* Background Video & overlay */}
            <video
              autoPlay
              muted
              loop
              playsInline
              className="absolute inset-0 w-full h-full object-cover opacity-30"
              src={video}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80 pointer-events-none rounded-2xl" />

            {/* Card Content */}
            <div className="relative z-10">
              <motion.span
                className="text-6xl block mb-6"
                animate={{ scale: [1, 1.1, 1], rotate: [0, 10, -10, 0] }}
                transition={{ duration: 4, repeat: Infinity, repeatType: "loop", ease: "easeInOut" }}
                initial={{ scale: 1 }}
              >
                {icon}
              </motion.span>

              <h3 className="text-2xl font-semibold text-white tracking-tight font-orbitron mb-4">
                {title}
              </h3>
              <div className="flex flex-wrap justify-center gap-4">
                {items.map(({ label, path }, i) => (
                  <Link
                    key={i}
                    to={path}
                    className="flex-1 min-w-[140px] sm:min-w-[180px] max-w-full px-5 py-2 text-sm bg-gray-800 bg-opacity-70 text-white font-medium rounded-full border border-indigo-500 shadow-sm hover:bg-indigo-600 hover:text-white transition text-center"
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
